import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import wh1 from '../assets/wh 1.jpg';
import wh2 from '../assets/wh 2.jpg';
import wh3 from '../assets/wh 3.jpg';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';

function Hero() {
    const images = [wh2, wh1, wh3];

    useEffect(() => {
        const alertmsg = sessionStorage.getItem("login");
        const userdetails = sessionStorage.getItem("userdetails")
            ? JSON.parse(sessionStorage.getItem("userdetails"))
            : null;

        if (alertmsg && userdetails) {
            alert(`${userdetails.username} is logged in successfully`);
            sessionStorage.removeItem("login");
            sessionStorage.removeItem("userdetails");
        }
    }, []);

    // const handlelogin = async (e) => {
    //     e.preventDefault();
    //     setError(null);
    //     setLoading(false);
    //     setErrorMessage(null);

    //     try {
    //         setLoading(true);

    //         const url = `${BASE_API}`;

    //         const response = await fetch(url, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify({
    //                 username: setSignin?.userName,
    //                 password: setSignin?.password
    //             }),
    //         });

    //         const result = await response.json();
    //         setLoading(false);

    //         if (response.ok) {
    //             if (result.data.user && result.data.user.length > 0) {
    //                 setLoading(false);
    //                 sessionStorage.setItem("Userdetails", JSON.stringify(result.data.user[0]));
    //                 Navigate("/")
    //                 alert("Login Successful")
    //             } else {
    //                 setLoading(false);
    //                 setErrorMessage(result.message || "User not found!");
    //                 console.error("Error during sign-in", result.message);
    //             }
    //         } else {
    //             setLoading(false);
    //             setErrorMessage(result.message || "User not found!");
    //             console.error("Error during sign-in", result.message);
    //         }

    //     } catch (err) {
    //         setErrorMessage("Something went wrong. Please try again later.");
    //         setLoading(false);
    //         setError("Something went wrong. Please try again later.");
    //     }
    // };

    useEffect(() => {
        const el = document.getElementById("heroCarousel");
        const carousel = new bootstrap.Carousel(el, {
            interval: 5000,
            ride: "carousel",
            pause: false,
            wrap: true,
        });

        return () => carousel.dispose();
    }, []);


    return (
        <section className="position-relative vh-100 overflow-hidden">
            {/* ================= CAROUSEL ================= */}
            <div
                id="heroCarousel"
                className="carousel slide carousel-fade h-100 position-relative"
                data-bs-ride="carousel"
                data-bs-wrap="true"
            >
                <style>
                    {`
      #heroCarousel .carousel-control-prev,
      #heroCarousel .carousel-control-next {
        width: 60px;
        height: 60px;
        top: 50%;
        transform: translateY(-50%);
        background-color: rgba(0,0,0,0.5);
        border-radius: 50%;
        border: none;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.3s ease, transform 0.2s ease;
      }

      #heroCarousel .carousel-control-prev:hover,
      #heroCarousel .carousel-control-next:hover {
        background-color: white;
        transform: translateY(-50%) scale(1.1);
      }

      #heroCarousel .carousel-control-prev .bi,
      #heroCarousel .carousel-control-next .bi {
        color: white;
        font-size: 1.5rem;
        transition: color 0.3s ease;
      }

      #heroCarousel .carousel-control-prev:hover .bi,
      #heroCarousel .carousel-control-next:hover .bi {
        color: black;
      }
    `}
                </style>

                <div className="carousel-inner h-100">
                    {images.map((img, idx) => (
                        <div key={idx} className={`carousel-item h-100 ${idx === 0 ? "active" : ""}`}>
                            <img
                                src={img}
                                className="w-100 h-100"
                                style={{ objectFit: "cover" }}
                                alt=""
                            />
                        </div>
                    ))}
                </div>

                {/* Previous Button */}
                <button
                    className="carousel-control-prev ms-4"
                    type="button"
                    data-bs-target="#heroCarousel"
                    data-bs-slide="prev"
                >
                    <i className="bi bi-chevron-left"></i>
                    <span className="visually-hidden">Previous</span>
                </button>

                {/* Next Button */}
                <button
                    className="carousel-control-next me-4"
                    type="button"
                    data-bs-target="#heroCarousel"
                    data-bs-slide="next"
                >
                    <i className="bi bi-chevron-right"></i>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>

            {/* ================= DARK OVERLAY ================= */}
            {/* <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ background: "rgba(0,0,0,0.55)", zIndex: 2 }}
            /> */}

            {/* ================= HERO CONTENT ================= */}
            {/* <div
                className="position-absolute top-50 start-50 mt-3 translate-middle text-white px-3"
                style={{ zIndex: 3, maxWidth: "900px" }}
            >
                <div className="mb-3 opacity-75 fs-4">★★★</div>

                <p className="text-uppercase fw-semibold opacity-75 mb-2">
                    We’re Tamil Nadu Warehousing
                </p>

                <h1 className="display-3 fw-bold mb-4 fs-2">
                    Efficient Storage Solutions
                </h1>

                <p className="lead mb-4 fs-5">
                    Supporting agriculture, industries, and logistics with cutting-edge storage facilities.
                </p>

                <div className="d-flex justify-content-center gap-3">
                    <button className="btn btn-lg display-6 " style={{ color: "white", backgroundColor: "rgba(9, 26, 58, 1)" }}>Explore Now</button>
                    <button className="btn btn-outline-light btn-lg px-5">Video Presentation</button>
                </div>
            </div> */}

            {/* ================= CURVED BOTTOM ================= */}
            <div
                className="position-absolute bottom-0 start-0 w-100"
                style={{ zIndex: 4, lineHeight: 0 }}
            >
                <svg viewBox="0 0 1440 320" preserveAspectRatio="none" style={{ width: "100%", height: "180px" }}>
                    <path
                        d="M0,0 C360,120 1080,120 1440,0 L1440,320 L0,320 Z"
                        fill="#fff"
                    />
                </svg>
            </div>


        </section >
    );
}

export default Hero;
